import React from "react"
import { BrindesFornecedorContextProvider } from "./context/BrindesFornecedorContextProvider"
import { BrindesFornecedor } from "./BrindesFornecedor"

export function Index() {
    return (
        <BrindesFornecedorContextProvider>
            <BrindesFornecedor />
        </BrindesFornecedorContextProvider>
    )
}
